export default __webpack_public_path__ + "static/media/Natas-Com-Nutella.9491c01e.jpg";